import { SearchIcon, XIcon } from 'lucide-react';
import { Input } from '@/components/ui/input.tsx';
import { ChangeEvent, useEffect } from 'react';
import { Button } from '@/components/ui/button.tsx';
import { useDebouncedInput } from '@/hooks/use-debounced-input.ts'; // Import debounce specifically

type Props = {
  onSearch: (search: string) => void;
};
export function ProjectSearchInput({ onSearch }: Props) {
  const { inputValue, debouncedValue, setInputValue, clearInput } = useDebouncedInput({});

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    onSearch(debouncedValue || '');
  }, [debouncedValue]);

  return (
    <div className="relative">
      <SearchIcon className="absolute left-2 top-2.5 h-4 w-4" />
      <Input
        placeholder="Search projects..."
        className="pl-8 input-no-border"
        value={inputValue}
        onChange={handleChange}
        autoFocus
      />
      {inputValue && ( // Conditionally render the clear button only when there's a value
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1/2 -translate-y-1/2 h-7 w-7 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
          onClick={clearInput}
        >
          <XIcon className="h-4 w-4" />
          <span className="sr-only">Clear</span>
        </Button>
      )}
    </div>
  );
}
